import { differenceInWeeks, format, isToday } from "date-fns";
import { getLocaleForDateFormat } from "./dateLocale";
import type { Locale } from "date-fns";

export const formatMessageDate = (
  messageDate: string,
  localeCode?: string,
): string => {
  const date = new Date(messageDate);
  const locale: Locale = getLocaleForDateFormat(localeCode);

  const diffInWeeks = differenceInWeeks(new Date(), date);

  if (isToday(date)) {
    return format(date, "p", { locale });
  }

  if (diffInWeeks < 1) {
    return format(date, "MMM d", { locale });
  }

  return format(date, "yyyy/MM/dd", { locale });
};
